module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/node_modules/symbol-observable/index.js
// module id = 459
// module chunks = 0